import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
const EP_UPDATE_QP_MUTATION = gql `
  mutation EP_updateQP($data: EPEditQPInput!) {
    ep_updateQP(data: $data) {
      sentForReview
      reason {
        message
        code
      }
    }
  }
`;
export function useEPUpdateQPMutation(options) {
    return useGQLMutation(EP_UPDATE_QP_MUTATION, {
        refetchQueries: ['EP_QPDetails'],
        ...options,
    });
}
